let accessToken: string = "";

export const setAccessToken = (input: string) => {
  accessToken = input;
};

export const getAccessToken = (): string => {
  return accessToken;
};
